import { render, staticRenderFns } from "./MyLearningGoal.vue?vue&type=template&id=5f8130e4&scoped=true&"
import script from "./MyLearningGoal.vue?vue&type=script&lang=js&"
export * from "./MyLearningGoal.vue?vue&type=script&lang=js&"
import style0 from "./MyLearningGoal.vue?vue&type=style&index=0&id=5f8130e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8130e4",
  null
  
)

export default component.exports